import Popup from 'reactjs-popup';
import Select from 'react-select'
import 'reactjs-popup/dist/index.css';
import React, { useEffect, useState } from 'react'
import { WardNameDataDDL } from '../../../../../../Components/CommonDDL/WardNameDataDDL';
import { SeverageWorkPeriodDataDDL } from '../../../../../../Components/CommonDDL/SeverageWorkPeriodDataDDL';
import { EquipmentNameDataDDL } from '../../../../../../Components/CommonDDL/STPEquipmentNameDDL';
import { useAuthState } from '../../../../../../Helper/Context';
import { useDispatch } from 'react-redux';
import { STPEquipmentWorkPostDataAPI } from '../../../../../../Redux/STPDashboardSlice/STPMaster/STPEquipmentWorkSlice';


export default function STPEquipmentWorkDataPopup(props) {

    const { handleOnCloseClick, open, Flag, handleIsPost, apiFlag, rowData, HWard, WLable } = props

    const userDetails = useAuthState();
    const { UserID, token, } = userDetails.user
    const dispatch = useDispatch()

    // const [ParameterType, setParameterType] = useState({
    //     DDL: [],
    //     ID: Flag === 'Update' ? rowData.m_IndicatorParameterTypeID : 0,
    //     Label: Flag === 'Update' ? rowData.indicatorName : "Select...",
    // })

    const [WardName, setWardName] = useState({
        DDL: [],
        ID: Flag === 'Update' ? rowData.m_WardID : 0,
        Label: Flag === 'Update' ? rowData.wardName : "Select...",
    })


    const [EquipmentName, setEquipmentName] = useState({
        DDL: [],
        ID: Flag === 'Update' ? rowData.m_stP_EquipmentMasterID : 0,
        Label: Flag === 'Update' ? rowData.equipmentDetails : "Select...",
    })

    const [WorkPeriod, setWorkPeriod] = useState({
        DDL: [],
        ID: Flag === 'Update' ? rowData.m_sW_WorkTypeID : 0,
        Label: Flag === 'Update' ? rowData.workType : "Select...",
    })

    const [EquipmentWork, setEquipmentWork] = useState(Flag === 'Update' ? rowData.equipmentName : '')


    const handlePost = () => {
        const data = {
            M_STP_EquipmentWorkID: Flag === 'Update' ? rowData.m_stP_EquipmentWorkID : '0',
            M_STP_EquipmentMasterID: EquipmentName.ID,
            M_STP_WorkPeriodID: WorkPeriod.ID,
            EquipmentName: EquipmentWork,
            M_UserID: UserID,
            token: token,
            Flag: Flag === 'Update' ? 'Update' : 'Insert',
            handleIsPost: handleIsPost,
            handleOnCloseClick: handleOnCloseClick
        }
        dispatch(STPEquipmentWorkPostDataAPI({ data }))
    }

    return (

        <Popup
            open={open} closeOnDocumentClick={false} onClose={handleOnCloseClick}
        >
            <div className="location_mob_pop modal-dialog modal-dialog-scrollable modal-xl" style={{ alignItems: "center", justifyContent: 'center' }}>
                <div className="modal-content road_ward_modal">
                    <div className="modal-header pl-4 p-1">
                        <h4 className="modal-title" id="staticBackdropLabel">Equipment Work</h4>
                        <button onClick={handleOnCloseClick} className="btn-close m-1 mr-3" type="button" />
                    </div>
                    <div className="modal-body">
                        <div className='inner-modal-body'>
                            <div className="row details-row">
                                <div className="col-lg-6 col-md-6">
                                    <WardNameDataDDL
                                        WardName={WardName}
                                        setWardName={setWardName}
                                        HWard={HWard}
                                        WLable={WLable}
                                    // Flag='ward'
                                    />

                                </div>
                                <div className="col-12 col-lg-6">
                                    <EquipmentNameDataDDL
                                        EquipmentName={EquipmentName}
                                        setEquipmentName={setEquipmentName}
                                        WardName={WardName}
                                        EquipmentType="0"
                                        UnitType='0'
                                        Flag={Flag}
                                    />

                                </div>
                                <div className="col-md-6 col-lg-6">
                                    <div className="form-group">
                                        <label className="d-block" htmlFor="NameofDepartment"><b>Equipment Work</b></label>
                                        <input type="text"
                                            className="form-control"
                                            id="EquipmentWork"
                                            value={EquipmentWork}
                                            onChange={(e) => setEquipmentWork(e.target.value)}
                                        />

                                    </div>
                                </div>
                                <div className="col-lg-6 col-md-6">
                                    <SeverageWorkPeriodDataDDL
                                        WorkPeriod={WorkPeriod}
                                        setWorkPeriod={setWorkPeriod}

                                    />

                                </div>
                            </div>
                            <div className="col-12 col-lg-12 pt-lg-4 pt-md-4 pt-3">
                                <div className="btn-action d-flex justify-content-end mt-lg-3">
                                    <button type='button'
                                        className="btn allBtn  float-right submit_btn"
                                        onClick={() => handlePost()}
                                        disabled={
                                            WardName.ID == 0 || EquipmentName.ID == 0 ||
                                            EquipmentWork == '' || WorkPeriod == 0
                                        }

                                    >{Flag === "Update" ? "Update" : "Save"} </button>

                                    <button type="button" className="btn addBtns cancel_btn ms-2 mr-2 mx-2  float-right" onClick={handleOnCloseClick} >Cancel</button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            {/* )} */}
        </Popup>
    )

}